import { useTranslation } from 'react-i18next'
import { Text } from '@chakra-ui/react'
import { Location, Region } from '@leid/api-locations'
import { Manager } from '@leid/api-managers'

import { CustomerInfo } from 'app/utils/authentication'
import { SortingInfo } from 'appTypes/mapper'

import LocationsList from '../LocationsList'
import RegionsList from '../RegionsList'
import { RegionWithAvailability } from '..'
import { JSX } from 'react'

type Props = {
  regions: RegionWithAvailability[]
  availableLocations: Location[]
  notAvailableLocations: Location[]

  manager: Manager | undefined
  managerAvailableLocations: Location[]
  managerNotAvailableLocations: Location[]

  selectedRegionId: number | undefined
  selectedLocationId: number | undefined
  customerInfo: CustomerInfo
  onRegionChange: (selectedRegion: Region | undefined) => void
  onLocationChange: (selectedLocation: Location | undefined) => void

  sortingInfo: SortingInfo | undefined
  setSortingInfo: (sortingInfo: SortingInfo | undefined) => void
}

const RegionsLocationsSection = (props: Props): JSX.Element => {
  const {
    regions,
    selectedRegionId,
    selectedLocationId,
    availableLocations,
    notAvailableLocations,
    manager,
    managerAvailableLocations,
    managerNotAvailableLocations,
    customerInfo,
    onRegionChange,
    onLocationChange,
    sortingInfo,
    setSortingInfo,
  } = props

  const { t } = useTranslation(['locations'])

  const hasManager =
    manager !== undefined && (managerAvailableLocations.length !== 0 || managerNotAvailableLocations.length !== 0)

  return (
    <>
      {hasManager ? (
        <>
          <Text fontWeight="semibold">{`${t('pickupPointsFor')} ${manager?.name ?? '-'}:`}</Text>

          <LocationsList
            locations={managerAvailableLocations}
            isDimmed={false}
            selectedLocationId={selectedLocationId}
            onLocationChange={onLocationChange}
          />
          <LocationsList
            locations={managerNotAvailableLocations}
            isDimmed={true}
            selectedLocationId={selectedLocationId}
            onLocationChange={onLocationChange}
          />
        </>
      ) : (
        <>
          {regions.length > 0 && (
            <>
              <RegionsList
                title={t('regions')}
                regions={regions}
                selectedRegionId={selectedRegionId}
                onRegionChange={onRegionChange}
                customerInfo={customerInfo}
                sortingInfo={sortingInfo}
                setSortingInfo={setSortingInfo}
              />
            </>
          )}

          {selectedRegionId && (
            <>
              {availableLocations.length > 0 && (
                <>
                  <Text fontWeight="semibold">{t(hasManager ? 'alsoAvailableAt' : 'availableAt')}</Text>
                  <LocationsList
                    locations={availableLocations}
                    isDimmed={false}
                    selectedLocationId={selectedLocationId}
                    onLocationChange={onLocationChange}
                  />
                </>
              )}

              {notAvailableLocations.length > 0 && (
                <LocationsList
                  locations={notAvailableLocations}
                  isDimmed={true}
                  selectedLocationId={selectedLocationId}
                  onLocationChange={onLocationChange}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export default RegionsLocationsSection
